import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadOwnListStatus: 'idle',
    loadOwnListError: undefined as any,
    loadOwnListLastArgs: undefined as any,
    loadOwnStatus: 'idle',
    loadOwnError: undefined as any,
    saveOwnStatus: 'idle',
    saveOwnError: undefined as any,
    deleteOwnStatus: 'idle',
    deleteOwnError: undefined as any,

    ownList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadOwnList = createAsyncThunk('ownerSlice/loadOwnList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ownerSlice.loadOwnListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/own/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadOwnListStatus } = getState().ownerSlice
        return loadOwnListStatus !== 'pending'
    }
})

export const loadOwn = createAsyncThunk('ownerSlice/loadOwn', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/own/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadOwnStatus } = getState().ownerSlice
        return loadOwnStatus !== 'pending'
    }
})

export const saveOwn = createAsyncThunk('ownerSlice/saveOwn', async ({ own }: any, { rejectWithValue }: any) => {
    let promises = []
    if (own?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/own/${ own?.HDR_ID }/`,
            prepareData(own),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/own/`,
            prepareData(own),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveOwnStatus } = getState().ownerSlice
        return saveOwnStatus !== 'pending'
    }
})

export const deleteOwn = createAsyncThunk('ownerSlice/deleteOwn', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/own/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteOwnStatus } = getState().ownerSlice
        return deleteOwnStatus !== 'pending'
    }
})

const OwnSlice = createSlice({
    name: 'ownerSlice',
    initialState,
    reducers: {
        resetloadOwnListError: (state) => {
            state.loadOwnListError = undefined
        },
        resetloadOwn: (state) => {
            state.formItem = undefined
            state.loadOwnError = undefined
        },
        resetloadOwnError: (state) => {
            state.loadOwnError = undefined
        },
        resetsaveOwn: (state) => {
            state.formItem = undefined
            state.saveOwnError = undefined
        },
        resetsaveOwnError: (state) => {
            state.saveOwnError = undefined
        },
        resetdeleteOwnError: (state) => {
            state.deleteOwnError = undefined
        },
        removeFromOwnListById: (state, action) => {
            state.ownList = state.ownList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromOwnListByIds: (state, action) => {
            state.ownList = state.ownList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ownList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadOwnListStatus = 'preloaded'
            state.loadOwnListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ownList = []
            state.loadOwnListStatus = 'idle'
            state.loadOwnListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadOwnList.pending, (state) => {
            state.loadOwnListStatus = 'pending'
            state.loadOwnListError = undefined
        })
        builder.addCase(loadOwnList.fulfilled, (state, action) => {
            state.loadOwnListStatus = 'idle'

            if (!action.payload) { return }

            state.loadOwnListLastArgs = action.payload.args

            {
                state.ownList = action.payload.data

            }
        })
        builder.addCase(loadOwnList.rejected, (state, action) => {
            state.loadOwnListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadOwnListError = action.error.message
            } else {
                state.loadOwnListError = action.payload
            }
        })

        builder.addCase(loadOwn.pending, (state) => {
            state.loadOwnStatus = 'pending'
            state.loadOwnError = undefined
        })
        builder.addCase(loadOwn.fulfilled, (state, action) => {
            state.loadOwnStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ownList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ownList.push(newItem) }
                else { state.ownList[i] = { ...state.ownList[i], ...newItem } }
            }
        })
        builder.addCase(loadOwn.rejected, (state, action) => {
            state.loadOwnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadOwnError = action.error.message
            } else {
                state.loadOwnError = action.payload
            }
        })

        builder.addCase(saveOwn.pending, (state) => {
            state.saveOwnStatus = 'pending'
            state.saveOwnError = undefined
        })
        builder.addCase(saveOwn.fulfilled, (state, action) => {
            state.saveOwnStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ownList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ownList.push(newItem) }
                else { state.ownList[i] = { ...state.ownList[i], ...newItem } }
            }
        })
        builder.addCase(saveOwn.rejected, (state, action) => {
            state.saveOwnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveOwnError = action.error.message
            } else {
                state.saveOwnError = action.payload
            }
        })

        builder.addCase(deleteOwn.pending, (state) => {
            state.deleteOwnStatus = 'pending'
            state.deleteOwnError = undefined
        })
        builder.addCase(deleteOwn.fulfilled, (state, action) => {
            state.deleteOwnStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ownList = state.ownList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ownList = state.ownList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteOwn.rejected, (state, action) => {
            state.deleteOwnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteOwnError = action.error.message
            } else {
                state.deleteOwnError = action.payload
            }
        })

    }
})

export const {
    resetloadOwnListError,
    resetloadOwn,
    resetloadOwnError,
    resetsaveOwn,
    resetsaveOwnError,
    resetdeleteOwnError,
    removeFromOwnListById,
    removeFromOwnListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = OwnSlice.actions
export default OwnSlice.reducer
